import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const useResponsive = () => {
  const { screen } = useWindowSize();
  const isMobile = ["xs", "sm", "md"].includes(screen);
  const isDesktop = ["lg", "xl", "xxl"].includes(screen);
  return {
    isMobile,
    isDesktop,
  };
};

export default useResponsive;
